export * from "./src/jira-software-pricing-page-v2.template";
